<section class="mat-typography mat-body">
  <div class="panel-expand-trigger">
    <div class="name-dropdown-expander" cdkOverlayOrigin #overlayorigin="cdkOverlayOrigin">
      <span>Hi, </span>
      <span>
        <a #expandableLink href="javascript:void(0)" (keydown)="tabIntoPanel($event)" (click)='expandPanel($event)'>{{ displayName }}</a>
      </span>
    </div>
  </div>
</section>
